export default __webpack_public_path__ + "a594ffe14ae275e5e6a61909d2630c8f.png";